import { Component, OnChanges, Input } from '@angular/core';
import * as c3 from 'c3';

@Component({
  selector: 'app-pie-chart-pdca-sql',
  templateUrl: './pie-chart-pdca-sql.component.html',
  styleUrls: ['./pie-chart-pdca-sql.component.scss']
})

// Created a pie chart component for PDCA section in dashboard
export class PieChartPdcaSqlComponent implements OnChanges {
  @Input() pdcaData: Array<any> = [];
  width = 0;
  height = 0;
  public innerwidth: any;
  constructor() {}
   ngOnChanges() {
    this.innerwidth = window.innerWidth;
    this.pieChartSizeUpdate();
    this.loadPieChart();
  }
  pieChartSizeUpdate() {
    if (this.innerwidth > 768 && this.innerwidth < 850) {
      this.width = 200;
      this.height = 200;
    } else if (this.innerwidth > 850 && this.innerwidth < 964) {
      this.width = 220;
      this.height = 220;
    } else if (this.innerwidth > 965 && this.innerwidth < 1024) {
      this.width = 250;
      this.height = 250;
    } else if (this.innerwidth > 1024 && this.innerwidth < 1280) {
      this.width = 300;
      this.height = 300;
    } else if (this.innerwidth > 1280 && this.innerwidth < 1366) {
      this.width = 340;
      this.height = 340;
    } else if (this.innerwidth > 1366 && this.innerwidth < 1536) {
      this.width = 340;
      this.height = 340;
    } else if (this.innerwidth > 1536) {
      this.width = 360;
      this.height = 360;
    }
  }
  loadPieChart() {
    const pdcaArrayData = Object.keys(this.pdcaData).map(v => new Array(v, this.pdcaData[v]));
    c3.generate({
      size: {
        height: this.height,
        width: this.width
      },
      data: {
        columns: pdcaArrayData,
        type: 'pie'
      },
      color: {
        // notstarted plan do check act
      pattern: ['#D27969', '#FDBF6F', '#82C7C2', '#97C782', '#C782C4', '#8F82C7']
    }
    });
  }
  onResize(event) {
    this.innerwidth = event.target.innerWidth;
    this.pieChartSizeUpdate();
    this.loadPieChart();
  }
}
